<template>
    <div>
        <button class="btn btn-default btn-xs" @click="showDialog = true">
            <span class="fa fa-plus"></span>
            Add to Watch List
        </button>

        <WatchListItemDialog
            v-if="showDialog"
            @hide="showDialog = false"
            :amazonProductId="amazonProductId"
            ></WatchListItemDialog>
    </div>
</template>

<script>
export default {
    components: {
        WatchListItemDialog: require('./WatchListItemDialog.vue').default,
    },
    props: ['amazonProductId'],
    data() {
        return {
            showDialog: false,
        };
    },
}
</script>
